import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 21v-13a4 4 0 1 1 4 4h-13","key":"svg-0"}],["path",{"d":"M8 16l-4 -4l4 -4","key":"svg-1"}]]

/**
 * IconArrowLoopLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbG9vcC1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMyAyMXYtMTNhNCA0IDAgMSAxIDQgNGgtMTMiIC8+CiAgPHBhdGggZD0iTTggMTZsLTQgLTRsNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-loop-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLoopLeft = createReactComponent('outline', 'arrow-loop-left', 'ArrowLoopLeft', __iconNode);

export default IconArrowLoopLeft;